(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-finishes"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['finishes'] = 'v1.2';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-closing"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['home-closing'] = 'v1.0';
  window.MM_BUILDS['home-layering'] = 'v1.0';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-collection"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['home-collection'] = 'v1.0';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-faq"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['home-faq'] = 'v1.1';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    (window.MM_BUILDS = window.MM_BUILDS || {})['home-hero'] = 'v2.0.5';

    /* ------------------------------------------------------------------
       Order-by strip (v1.6). Everything runs on Irish time, because that is
       where the orders are made, not on the visitor's clock. Working days
       only (Mon-Fri). Dispatch days come from the section settings
       (default 3 = top of "dispatched in 1 to 3 days").
       Countdown rule: it only shows when the promised dispatch date really
       moves at the next midnight in Ireland. Fri and Sat orders get the
       same date as Sun, so those days show the date with no countdown.
       No fake timers that reset.
       Delivery days above 0 switch to the static "get it by" wording.
       ------------------------------------------------------------------ */
    var TZ = 'Europe/Dublin';
    function dublinNow() {
      try {
        var p = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        var h = +p.hour % 24;
        return { day: Date.UTC(+p.year, +p.month - 1, +p.day), secs: h * 3600 + (+p.minute) * 60 + (+p.second) };
      } catch (e) {
        var d = new Date();
        return { day: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() };
      }
    }
    var DAY = 86400000;
    /* days are UTC-midnight timestamps standing for an Irish calendar date */
    function addWorkingDays(day, n) {
      var out = day, added = 0;
      while (added < n) {
        out += DAY;
        var wd = new Date(out).getUTCDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return out;
    }
    var WD = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function ordinal(n) {
      var t = n % 100;
      if (t >= 11 && t <= 13) return n + 'th';
      return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
    }
    /* "Thursday 15th Oct", or "Thu 15th Oct" when short */
    function fmtDate(day, short) {
      var d = new Date(day), w = WD[d.getUTCDay()];
      return (short ? w.slice(0, 3) : w) + ' ' + ordinal(d.getUTCDate()) + ' ' + MO[d.getUTCMonth()];
    }
    function parseDay(s) {
      var m = String(s || '').match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null;
    }
    /* v1.9: the visitor's own calendar date (midnight to midnight), for [days] */
    function localDay() {
      var d = new Date();
      return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
    }
    /* v1.9: "1 day" / "9 days" ([days] in the delivery and Christmas texts) */
    function fmtDays(n) {
      n = Math.round(n);
      return n > 0 ? n + (n === 1 ? ' day' : ' days') : '';
    }
    /* v1.9: a token with no value is taken out with the brackets around it
       and the space before it, so "[days]" or "()" can never show. */
    function prune(tpl, vals) {
      return String(tpl).replace(/\s*\(\s*\[(time|date|xmas|days)\]\s*\)|\s*\[(time|date|xmas|days)\]/g, function (m, a, b) {
        return vals[a || b] ? m : '';
      });
    }
    function fmtLeft(secs) {
      var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
      if (h > 0) return h + 'h ' + (m < 10 ? '0' : '') + m + 'm';
      return m + 'm ' + (s < 10 ? '0' : '') + s + 's';
    }
    /* Fills el from a template. [time], [date], [xmas] and [days] become
       styled spans; " · " becomes a soft separator. Text nodes only, so
       nothing typed in the theme editor is ever read as HTML. */
    function fill(el, tpl, vals) {
      var key = tpl + '|' + JSON.stringify(vals);
      if (el.__k === key) return;
      el.__k = key;
      while (el.firstChild) el.removeChild(el.firstChild);
      prune(tpl, vals).split(/(\[time\]|\[date\]|\[xmas\]|\[days\]| · )/).forEach(function (part) {
        if (!part) return;
        var span;
        if (part === ' · ') { span = document.createElement('span'); span.className = 'mmf-strip__sep'; span.textContent = '·'; }
        else if (part === '[time]') { span = document.createElement('span'); span.className = 'mmf-strip__t'; span.textContent = vals.time || ''; }
        else if (part === '[date]' || part === '[xmas]' || part === '[days]') { span = document.createElement('b'); span.textContent = vals[part.slice(1, -1)] || ''; }
        if (span) el.appendChild(span); else el.appendChild(document.createTextNode(part));
      });
    }
    function paintStrip(s) {
      var out = s.querySelector('[data-mmf-orderby-text]');
      if (!out) return;
      var dispatch = parseInt(s.getAttribute('data-dispatch-days'), 10) || 3;
      var delivery = parseInt(s.getAttribute('data-delivery-days'), 10) || 0;
      var now = dublinNow();
      var dDay = addWorkingDays(now.day, dispatch + delivery);
      var date = fmtDate(dDay);
      var left = Math.max(0, 86400 - now.secs);
      var moves = addWorkingDays(now.day, dispatch + delivery) !== addWorkingDays(now.day + DAY, dispatch + delivery);
      var tpl = null, vals = { date: date, time: fmtLeft(left), days: fmtDays((dDay - localDay()) / DAY) }, live = false, shortTpl = null, mode = 'static';

      var xFrom = parseDay(s.getAttribute('data-xmas-from')), xLast = parseDay(s.getAttribute('data-xmas-last'));
      if (xFrom !== null && xLast !== null && now.day >= xFrom && now.day <= xLast) {
        var daysLeft = Math.round((xLast - now.day) / DAY) + 1;     // today counts
        vals.xmas = fmtDate(xLast);
        if (daysLeft === 1 && s.getAttribute('data-text-xmas-today')) { tpl = s.getAttribute('data-text-xmas-today'); live = true; mode = 'xmas-today'; }
        else if (daysLeft <= 7 && s.getAttribute('data-text-xmas-soon')) { tpl = s.getAttribute('data-text-xmas-soon'); mode = 'xmas-soon'; }
        else { tpl = s.getAttribute('data-text-xmas'); mode = 'xmas'; }
        if (tpl) vals.days = fmtDays(daysLeft);              // Christmas texts: days left to order
      }
      if (!tpl) {
        if (delivery > 0) {
          /* v1.8: same honesty rule as the dispatch countdown. A timer only
             shows when the promised date really moves at midnight. */
          var dT = s.getAttribute('data-text-delivery') || '';
          if (dT.indexOf('[time]') >= 0 && !moves) tpl = s.getAttribute('data-text-delivery-static') || dT;
          else { tpl = dT; if (dT.indexOf('[time]') >= 0) { live = true; mode = 'count'; } }
        }
        else if (moves && s.getAttribute('data-text-count')) { tpl = s.getAttribute('data-text-count'); shortTpl = s.getAttribute('data-text-count-short'); live = true; mode = 'count'; }
        else tpl = s.getAttribute('data-text-dispatch');
      }
      if (!tpl) return;
      s.classList.toggle('is-live', live);
      /* One line, always. Tries, in order: full wording with the date written
         out, short wording, then short wording with "Thu" instead of
         "Thursday". The step that fits is remembered per mode and screen
         width, so it is not re-measured every second. */
      var valsS = {};
      for (var k in vals) valsS[k] = vals[k];
      valsS.date = fmtDate(dDay, true);
      if (xLast !== null) valsS.xmas = fmtDate(xLast, true);
      var steps = [[tpl, vals]];
      if (shortTpl) steps.push([shortTpl, vals]);
      steps.push([shortTpl || tpl, valsS]);
      /* v1.9: last resort on narrow phones, drop "([days])" rather than cut the text */
      if (/\(\s*\[days\]\s*\)/.test(shortTpl || tpl)) {
        var valsN = {};
        for (var k2 in valsS) valsN[k2] = valsS[k2];
        valsN.days = '';
        steps.push([shortTpl || tpl, valsN]);
      }
      if (out.__mode !== mode) { out.__mode = mode; out.__lvl = 0; }
      var lvl = Math.min(out.__lvl || 0, steps.length - 1);
      fill(out, steps[lvl][0], steps[lvl][1]);
      while (lvl < steps.length - 1 && out.scrollWidth > out.clientWidth + 1) { lvl++; fill(out, steps[lvl][0], steps[lvl][1]); }
      out.__lvl = lvl;
    }
    function paintStrips(root) {
      var strips = (root || document).querySelectorAll('[data-mmf-orderby]');
      for (var i = 0; i < strips.length; i++) paintStrip(strips[i]);
      if (strips.length && !paintStrips.timer) {
        paintStrips.timer = setInterval(function () {
          var all = document.querySelectorAll('[data-mmf-orderby]');
          for (var k = 0; k < all.length; k++) paintStrip(all[k]);
        }, 1000);
        window.addEventListener('resize', function () {
          var all = document.querySelectorAll('[data-mmf-orderby] [data-mmf-orderby-text]');
          for (var k = 0; k < all.length; k++) { all[k].__k = null; all[k].__lvl = 0; }
        }, { passive: true });
      }
    }

    /* ------------------------------------------------------------------
       Place search. Built from the configurator's geocoder (B5.62): same
       result parsing, "too big to model" rule and postcode handling.
       v1.4 speed change (7 Oct, measured on the live site): the public
       Photon server answers in 6-11 s, Nominatim in 0.1-0.7 s and
       postcodes.io in 0.15 s. So Enter / Build it never waits on Photon:
       postcodes go to postcodes.io / Nominatim, everything else to
       Nominatim. Photon is only used for the as-you-type list, in the
       background, and never blocks anything. (Nominatim's rules forbid
       as-you-type use, so it only runs on Enter or for a full postcode.)
       ------------------------------------------------------------------ */
    function visitorCountry() {
      try { return String((window.Shopify && window.Shopify.country) || '').toLowerCase(); }
      catch (e) { return ''; }
    }

    function makeGeocoder(cfg) {
      var pending = null;
      var FAST_MS = 2500, SLOW_MS = 5000;
      function run(url, exclusive, ms) {
        if (exclusive && pending) pending.abort();
        var ctrl = ('AbortController' in window) ? new AbortController() : null;
        if (exclusive) pending = ctrl;
        var timedOut = false, tid = null;
        if (ctrl && ms) tid = setTimeout(function () { timedOut = true; ctrl.abort(); }, ms);
        return fetch(url, ctrl ? { signal: ctrl.signal } : undefined).then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        }).then(function (j) {
          if (tid) clearTimeout(tid);
          return j;
        }, function (e) {
          if (tid) clearTimeout(tid);
          if (timedOut) { var t = new Error('geocoder timeout'); t.name = 'GeoTimeout'; throw t; }
          throw e;
        });
      }
      var BIG_KINDS = { country: 1, state: 1, region: 1, province: 1, county: 1,
        state_district: 1, continent: 1, archipelago: 1, ocean: 1, sea: 1,
        macroregion: 1, macrocounty: 1, dependency: 1, territory: 1, island: 1 };
      function isBig(kind, span) {
        if (!kind || !BIG_KINDS[kind]) return false;
        if (kind === 'island') return span > 1.5;
        return !(span > 0) || span > 1.5;
      }
      function fromPhoton(json) {
        return ((json && json.features) || []).map(function (f) {
          var p = f.properties || {}, c = (f.geometry || {}).coordinates || [];
          var name = p.name || [p.housenumber, p.street].filter(Boolean).join(' ') || p.city || p.county || '';
          var ctx = [p.street && p.name ? p.street : null, p.district, p.city, p.state, p.country]
            .filter(Boolean).join(', ');
          var ex = p.extent, span = (ex && ex.length === 4)
            ? Math.max(Math.abs(ex[2] - ex[0]), Math.abs(ex[1] - ex[3])) : 0;
          var kind = BIG_KINDS[p.osm_value] ? p.osm_value : p.type;
          return { name: name, ctx: ctx, lat: c[1], lon: c[0], big: isBig(kind, span) };
        }).filter(function (o) { return o.name && o.lat != null; });
      }
      function fromNominatim(json) {
        if (json && json.display_name) json = [json];
        return (json || []).map(function (r) {
          var parts = String(r.display_name || '').split(', ');
          var bb = (r.boundingbox || []).map(parseFloat), span = bb.length === 4
            ? Math.max(Math.abs(bb[1] - bb[0]), Math.abs(bb[3] - bb[2])) : 0;
          var kind = BIG_KINDS[r.addresstype] ? r.addresstype : (r['class'] === 'place' ? r.type : '');
          return { name: parts.shift(), ctx: parts.join(', '),
                   lat: parseFloat(r.lat), lon: parseFloat(r.lon), big: isBig(kind, span) };
        });
      }
      function nominatimSearch(text, focus) {
        var vb = '';
        if (focus && focus.box) {
          vb = '&viewbox=' + focus.box.join(',');
        } else if (focus && isFinite(focus.lat) && isFinite(focus.lon)) {
          vb = '&viewbox=' + (focus.lon - 1).toFixed(3) + ',' + (focus.lat + 1).toFixed(3) + ',' +
               (focus.lon + 1).toFixed(3) + ',' + (focus.lat - 1).toFixed(3);
        }
        return run('https://nominatim.openstreetmap.org/search?format=json&limit=6&q=' +
          encodeURIComponent(text) + vb, true, SLOW_MS).then(fromNominatim);
      }
      /* v1.8: MapTiler geocoding. Fast enough to run on every keystroke and
         allowed to (Nominatim's rules forbid that). Same result shape as the
         other two, same "too big to model" rule. */
      var MT_BIG = { country: 'country', region: 'region', subregion: 'state_district',
        county: 'county', continental_marine: 'ocean', major_landform: 'island' };
      /* Landmarks: MapTiler leaves POIs out unless asked ("eiffel tower" gave
         streets in the Philippines). A trailing street-type abbreviation is
         spelled out ("grafton st" gave towns in the US). */
      var MT_TYPES = 'poi,address,road,place,neighbourhood,locality,municipality,municipal_district,postal_code,county,region,subregion,country,joint_municipality,joint_submunicipality,continental_marine,major_landform';
      var MT_ABBR = { st: 'street', rd: 'road', ave: 'avenue', av: 'avenue', sq: 'square', ln: 'lane',
        dr: 'drive', ct: 'court', tce: 'terrace', cres: 'crescent', pk: 'park', blvd: 'boulevard' };
      function mtText(text) {
        return String(text).replace(/[;\/]+/g, ' ').trim()
          .replace(/\s(st|rd|ave|av|sq|ln|dr|ct|tce|cres|pk|blvd)\.?$/i, function (m, a) { return ' ' + MT_ABBR[a.toLowerCase()]; });
      }
      function fromMapTiler(json) {
        return ((json && json.features) || []).map(function (f) {
          var c = f.center || (f.geometry && f.geometry.coordinates) || [];
          var parts = String(f.place_name || f.text || '').split(', ');
          var name = parts.shift() || f.text || '';
          var bb = f.bbox, span = (bb && bb.length === 4)
            ? Math.max(Math.abs(bb[2] - bb[0]), Math.abs(bb[3] - bb[1])) : 0;
          var kind = MT_BIG[(f.place_type || [])[0]] || '';
          return { name: name, ctx: parts.join(', '), lat: +c[1], lon: +c[0], big: isBig(kind, span) };
        }).filter(function (o) { return o.name && isFinite(o.lat) && isFinite(o.lon); });
      }
      function maptiler(text, focus, auto, ms) {
        var prox = (focus && isFinite(focus.lat) && isFinite(focus.lon))
          ? focus.lon.toFixed(4) + ',' + focus.lat.toFixed(4) : 'ip';
        var q = mtText(text);
        return run('https://api.maptiler.com/geocoding/' + encodeURIComponent(q) + '.json?key=' +
          encodeURIComponent(cfg.mtKey) + '&limit=6&language=en&fuzzyMatch=true&autocomplete=' +
          (auto ? 'true' : 'false') + '&proximity=' + prox + '&types=' + MT_TYPES, true, ms).then(fromMapTiler);
      }
      function photonList(text, focus) {
        return run(cfg.photonBase.replace(/\/$/, '') + '/api/?limit=6&lang=en&q=' +
          encodeURIComponent(text) + bias(focus), true, 9000).then(fromPhoton)
          .then(function (l) { l.forEach(function (o) { o.src = 'osm'; }); return l; });
      }
      function bias(focus) {
        if (!focus) return '';
        return '&lat=' + focus.lat.toFixed(5) + '&lon=' + focus.lon.toFixed(5);
      }

      /* Postcodes (same as configurator B5.62). */
      var PC_EIR = /^\s*([AC-FHKNPRTV-Y]\d{2}|D6W)\s*([0-9AC-FHKNPRTV-Y]{4})\s*$/i;
      var PC_UK = /^\s*([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})\s*$/i;
      var PC_GEN = /^\s*(\d{4,5}|\d{4}\s?[A-Z]{2}|\d{3}\s\d{2}|\d{2}-\d{3}|\d{4}-\d{3})\s*$/i;
      var PC_EUROPE = ['ie','gb','fr','nl','be','lu','es','pt','it','mt','at','ch','dk','se','no','fi',
        'pl','cz','sk','hu','si','hr','ro','bg','gr','cy','ee','lv','lt','is','de'];
      function pcKind(text) {
        var m;
        if ((m = PC_EIR.exec(text))) return { kind: 'eir', code: (m[1] + ' ' + m[2]).toUpperCase() };
        if ((m = PC_UK.exec(text))) return { kind: 'uk', code: (m[1] + ' ' + m[2]).toUpperCase() };
        if ((m = PC_GEN.exec(text))) return { kind: 'gen', code: m[1].toUpperCase() };
        return null;
      }
      function pcSquash(s) { return String(s || '').replace(/[\s-]/g, '').toUpperCase(); }
      function photonRaw(text, limit, ms) {
        return run(cfg.photonBase.replace(/\/$/, '') + '/api/?limit=' + (limit || 10) + '&lang=en&q=' +
          encodeURIComponent(text), true, ms || FAST_MS).then(function (j) {
            var out = [];
            ((j && j.features) || []).forEach(function (f) {
              var o = fromPhoton({ features: [f] })[0];
              if (!o) return;
              var p = f.properties || {};
              o.cc = String(p.countrycode || '').toLowerCase();
              o.isPostcode = p.osm_value === 'postcode';
              out.push(o);
            });
            return out;
          });
      }
      function exactPostcode(list, code) {
        var want = pcSquash(code);
        return list.filter(function (o) { return pcSquash(o.name) === want; });
      }
      function nominatimPostcode(code, ccs) {
        return run('https://nominatim.openstreetmap.org/search?format=json&limit=6&postalcode=' +
          encodeURIComponent(code) + (ccs ? '&countrycodes=' + ccs : ''), true, SLOW_MS)
          .then(fromNominatim)
          .then(function (l) { return l.map(function (o) { o.name = code; return o; }); });
      }
      function soft(e) { if (e && e.name === 'AbortError') throw e; return []; }
      /* Eircode: Nominatim first (fast), Photon only as a short second try.
         Only an exact match counts; a near miss lands on someone else's
         house, so "not found" is the better answer. */
      function eircode(code) {
        return run('https://nominatim.openstreetmap.org/search?format=json&limit=3&countrycodes=ie&q=' +
          encodeURIComponent(code), true, SLOW_MS).then(fromNominatim)
          .then(function (l) { return exactPostcode(l, code).slice(0, 1); }).catch(soft)
          .then(function (hit) {
            if (hit.length) return hit;
            return photonRaw(code, 6, 3000)
              .then(function (l) { return exactPostcode(l, code).slice(0, 1); }).catch(soft);
          });
      }
      function ukPostcode(code) {
        return run('https://api.postcodes.io/postcodes/' + encodeURIComponent(code), true, FAST_MS)
          .then(function (j) {
            var r = j && j.result;
            if (!r || r.latitude == null) return [];
            return [{ name: r.postcode || code,
                      ctx: [r.admin_ward, r.admin_district, r.country].filter(Boolean).join(', '),
                      lat: r.latitude, lon: r.longitude, big: false }];
          })
          .catch(function (e) {
            if (e && e.name === 'AbortError') throw e;
            return nominatimPostcode(code, 'gb').catch(function () { return []; });
          });
      }
      /* Numeric / EU postcodes: the visitor's own country first, then Europe. */
      function genericPostcode(code) {
        var cc = visitorCountry();
        var first = cc ? nominatimPostcode(code, cc) : Promise.resolve([]);
        return first.then(function (l) {
          return l.length ? l : nominatimPostcode(code, PC_EUROPE.join(','));
        }).then(function (l) { return l.slice(0, 6); }).catch(soft);
      }
      function postcodeQuery(text) {
        var k = pcKind(text);
        if (!k) return null;
        if (k.kind === 'eir') return eircode(k.code);
        if (k.kind === 'uk') return ukPostcode(k.code);
        return genericPostcode(k.code);
      }

      var cache = {};
      function remember(key, p) {
        return p.then(function (res) { if (res && res.length) cache[key] = res; return res; });
      }
      return {
        pcKind: pcKind,
        cached: function (text) { return cache['s:' + text.toLowerCase()] || null; },
        /* As-you-type list. Full postcodes use the fast postcode lookups.
           Anything else asks Photon in the background (slow right now); a
           slow or failed answer just means no list, it never switches the
           list off for the rest of the visit. null = nothing to show. */
        suggest: function (text, focus) {
          var key = 's:' + text.toLowerCase();
          if (cache[key]) return Promise.resolve(cache[key]);
          var pcS = postcodeQuery(text);
          if (pcS) return remember(key, pcS);
          var first = cfg.mtKey
            ? maptiler(text, focus, true, 3500).catch(function (e) {
                if (e && e.name === 'AbortError') throw e;
                return photonList(text, focus);
              })
            : photonList(text, focus);
          return remember(key, first)
            .catch(function (e) { if (e && e.name === 'AbortError') throw e; return null; });
        },
        /* Place name for a point (Use my current location). */
        reverse: function (lat, lon) {
          if (!cfg.mtKey) return Promise.resolve('');
          return run('https://api.maptiler.com/geocoding/' + lon.toFixed(6) + ',' + lat.toFixed(6) +
            '.json?key=' + encodeURIComponent(cfg.mtKey) + '&limit=1&language=en', false, 2500)
            .then(function (j) { var o = fromMapTiler(j)[0]; return o ? o.name : ''; })
            .catch(function () { return ''; });
        },
        /* Enter / Build it. Never waits on Photon unless Nominatim fails. */
        search: function (text, focus) {
          var key = 's:' + text.toLowerCase();
          if (cache[key]) return Promise.resolve(cache[key]);
          var pcQ = postcodeQuery(text);
          if (pcQ) return remember(key, pcQ);
          function nomThenPhoton() {
            return nominatimSearch(text, focus).catch(function (e) {
              if (e && e.name === 'AbortError') throw e;
              return run(cfg.photonBase.replace(/\/$/, '') + '/api/?limit=6&lang=en&q=' +
                encodeURIComponent(text) + bias(focus), true, SLOW_MS).then(fromPhoton);
            });
          }
          if (!cfg.mtKey) return remember(key, nomThenPhoton());
          return remember(key, maptiler(text, focus, false, FAST_MS).then(function (l) {
            return l.length ? l : nomThenPhoton();
          }, function (e) {
            if (e && e.name === 'AbortError') throw e;
            return nomThenPhoton();
          }));
        }
      };
    }

    /* Coordinates typed or pasted, as in the configurator: decimal pairs,
       N/S/E/W forms, degrees-minutes-seconds and full Google Maps links. */
    function parseCoords(raw) {
      var s = String(raw || '').trim();
      if (!s) return null;
      function finish(lat, lon) {
        if (!isFinite(lat) || !isFinite(lon)) return null;
        if (Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
        if (lat === 0 && lon === 0) return null;
        return { lat: lat, lon: lon };
      }
      if (/^https?:\/\//i.test(s) || /(google\.[a-z.]+\/maps|goo\.gl|maps\.app)/i.test(s)) {
        var at = s.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
        if (at) return finish(+at[1], +at[2]);
        var q = s.match(/[?&](?:q|ll|center|daddr)=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/i);
        if (q) return finish(+q[1], +q[2]);
        var place = s.match(/\/place\/(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
        if (place) return finish(+place[1], +place[2]);
        if (/goo\.gl|maps\.app/i.test(s)) return { shortLink: true };
        return null;
      }
      var dms = s.match(
        /^\s*(\d+)[°\s:]+(\d+)['′\s:]+([\d.]+)["″\s]*\s*([NSns])[,\s]+(\d+)[°\s:]+(\d+)['′\s:]+([\d.]+)["″\s]*\s*([EWew])\s*$/);
      if (dms) {
        var la = (+dms[1]) + (+dms[2]) / 60 + (+dms[3]) / 3600;
        var lo = (+dms[5]) + (+dms[6]) / 60 + (+dms[7]) / 3600;
        if (/[Ss]/.test(dms[4])) la = -la;
        if (/[Ww]/.test(dms[8])) lo = -lo;
        return finish(la, lo);
      }
      var hemi = s.match(
        /^\s*([NSns])?\s*(-?[\d.]+)\s*°?\s*([NSns])?[,\s]+([EWew])?\s*(-?[\d.]+)\s*°?\s*([EWew])?\s*$/);
      if (hemi && hemi[2] && hemi[5]) {
        var ns = hemi[1] || hemi[3], ew = hemi[4] || hemi[6];
        var lat2 = Math.abs(+hemi[2]), lon2 = Math.abs(+hemi[5]);
        if (!ns && !ew) { lat2 = +hemi[2]; lon2 = +hemi[5]; }
        else {
          if (/[Ss]/.test(ns || '')) lat2 = -lat2;
          if (/[Ww]/.test(ew || '')) lon2 = -lon2;
        }
        return finish(lat2, lon2);
      }
      return null;
    }
    function fmtCoord(lat, lon) {
      return Math.abs(lat).toFixed(4) + '° ' + (lat >= 0 ? 'N' : 'S') + '   ' +
             Math.abs(lon).toFixed(4) + '° ' + (lon >= 0 ? 'E' : 'W');
    }

    /* The configurator biases its search toward the map centre. The homepage
       has no map, so it biases toward the visitor's country instead. */
    var CENTRES = { ie: [53.35, -6.26], gb: [52.5, -1.6], fr: [46.6, 2.4], nl: [52.2, 5.3],
      be: [50.6, 4.6], lu: [49.7, 6.1], es: [40.4, -3.7], pt: [39.6, -8.0], it: [42.8, 12.5],
      at: [47.6, 14.1], ch: [46.8, 8.2], dk: [56.0, 10.0], se: [59.3, 16.0], no: [60.5, 8.5],
      fi: [61.9, 25.7], pl: [52.1, 19.4], cz: [49.8, 15.5], de: [51.1, 10.4], gr: [39.1, 22.9],
      hr: [45.1, 15.2], hu: [47.2, 19.5], ro: [45.9, 24.9], si: [46.1, 14.8], sk: [48.7, 19.7] };
    /* Nominatim search box (west,north,east,south) for the two main markets;
       elsewhere a box around the country centre. Results outside still come
       back, they just rank lower. */
    var BOXES = { ie: [-10.7, 55.45, -5.9, 51.4], gb: [-8.7, 60.9, 1.8, 49.8] };
    function focusPoint() {
      var cc = visitorCountry();
      var c = CENTRES[cc];
      if (!c) return null;
      return { lat: c[0], lon: c[1],
               box: BOXES[cc] || [c[1] - 3, c[0] + 2.5, c[1] + 3, c[0] - 2.5] };
    }

    var PIN = '<svg class="mmf-sugg__pin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>';

    var LENS = '<svg class="mmf-sugg__pin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.2-4.2"/></svg>';
    var LOC = '<svg class="mmf-sugg__pin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="3.5"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3"/><circle cx="12" cy="12" r="7.5"/></svg>';
    var CLOCK = '<svg class="mmf-sugg__pin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
    function norm(t) { return String(t || '').toLowerCase().replace(/[,\s]+/g, ' ').trim(); }
    /* Bold the parts of a name that match what was typed, at word starts. */
    function highlight(el, text, q) {
      el.textContent = '';
      text = String(text || '');
      var low = text.toLowerCase(), marks = [];
      norm(q).split(' ').forEach(function (t) {
        if (!t) return;
        var from = 0, i;
        while ((i = low.indexOf(t, from)) >= 0) {
          if (i === 0 || /[\s,.\-'(\/]/.test(low.charAt(i - 1))) { marks.push([i, i + t.length]); break; }
          from = i + 1;
        }
      });
      marks.sort(function (a, b) { return a[0] - b[0]; });
      var pos = 0;
      marks.forEach(function (m) {
        if (m[0] < pos) m[0] = pos;
        if (m[1] <= m[0]) return;
        if (m[0] > pos) el.appendChild(document.createTextNode(text.slice(pos, m[0])));
        var b = document.createElement('b');
        b.textContent = text.slice(m[0], m[1]);
        el.appendChild(b);
        pos = m[1];
      });
      if (pos < text.length) el.appendChild(document.createTextNode(text.slice(pos)));
    }
    /* Last 3 places picked on this device. Convenience only: if storage is
       blocked the list is simply empty. */
    var RECENT_KEY = 'mmf-recent-places';
    function recentGet() {
      try {
        var a = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(a) ? a.filter(function (o) { return o && o.name && isFinite(o.lat) && isFinite(o.lon); }).slice(0, 3) : [];
      } catch (e) { return []; }
    }
    function recentAdd(o) {
      try {
        var a = recentGet().filter(function (x) { return !(x.name === o.name && (x.ctx || '') === (o.ctx || '')); });
        a.unshift({ name: o.name, ctx: o.ctx || '', lat: o.lat, lon: o.lon });
        window.localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 3)));
      } catch (e) {}
    }
    /* Keep earlier suggestions that still fit what is typed now, so the list
       does not blank out while a new answer is on its way. */
    function fits(res, q) {
      var want = norm(q);
      return res.filter(function (o) { return !o.coords && norm(o.name + ' ' + (o.ctx || '')).indexOf(want) >= 0; });
    }

    function wire(form) {
      if (form.getAttribute('data-mmf-ready')) return;
      form.setAttribute('data-mmf-ready', '1');
      var input = form.querySelector('.mmf-search__input');
      var list = form.querySelector('.mmf-sugg');
      var btn = form.querySelector('.mmf-search__btn');
      if (!input || !list || !btn) return;
      /* v2.0.5: warm up the configurator while they type. Same URLs as the
         configurator page uses, so the browser serves them from its cache. */
      var warmed = false;
      function warm() {
        if (warmed) return;
        warmed = true;
        try {
          var head = document.head || document.documentElement;
          var add = function (rel, href, as, cors) {
            var l = document.createElement('link');
            l.rel = rel; l.href = href;
            if (as) l.as = as;
            if (cors) l.crossOrigin = 'anonymous';
            head.appendChild(l);
          };
          add('preconnect', 'https://api.maptiler.com', null, true);
          add('preconnect', 'https://cdn.jsdelivr.net');
          add('preload', 'https://cdn.jsdelivr.net/npm/maplibre-gl@5/dist/maplibre-gl.css', 'style');
          add('preload', 'https://cdn.jsdelivr.net/npm/maplibre-gl@5/dist/maplibre-gl.js', 'script');
          (form.getAttribute('data-warm-js') || '').split(/\s+/).forEach(function (u) {
            if (u) add('preload', u, 'script');
          });
        } catch (eW) {}
      }
      input.addEventListener('focus', warm);
      input.addEventListener('pointerdown', warm);
      var cfgPath = form.getAttribute('data-cfg') || '/pages/configurator';
      var mtKey = form.getAttribute('data-mt-key') || '';
      var locLabel = form.getAttribute('data-locate') || '';
      var canLocate = !!(locLabel && navigator.geolocation && window.isSecureContext !== false);
      /* v2.0.4: not offered again once refused (this visit), or while the
         browser has it blocked for this site. */
      try { if (sessionStorage.getItem('mmf-loc-off') === '1') canLocate = false; } catch (eS) {}
      try {
        if (canLocate && navigator.permissions && navigator.permissions.query) {
          navigator.permissions.query({ name: 'geolocation' }).then(function (ps) {
            if (ps && ps.state === 'denied') canLocate = false;
          }).catch(function () {});
        }
      } catch (eP) {}
      var geo = makeGeocoder({ photonBase: form.getAttribute('data-photon') || 'https://photon.komoot.io', mtKey: mtKey });
      var items = [], active = -1, timer = null, seq = 0, shownFor = '';
      var MIN = 2, WAIT = mtKey ? 90 : 150;

      function link(params) { return cfgPath + (cfgPath.indexOf('?') >= 0 ? '&' : '?') + params; }
      function busy(on) { btn.disabled = !!on; btn.classList.toggle('is-busy', !!on); }
      function open() { list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
      function hide() {
        list.hidden = true; list.innerHTML = ''; items = []; active = -1; shownFor = '';
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }
      function message(text) {
        list.innerHTML = ''; items = []; active = -1; shownFor = '';
        var d = document.createElement('div');
        d.className = 'mmf-sugg__msg';
        d.setAttribute('role', 'status');
        d.textContent = text;
        list.appendChild(d);
        open();
      }
      function noMatch(q) {
        var k = geo.pcKind(q);
        message(k && k.kind === 'eir'
          ? "We can't pinpoint that Eircode on the map yet. Try your street and town instead."
          : 'No matches. Try a street, town or landmark.');
      }
      function tooBig(o) {
        message(o.name + ' covers too big an area to model. Try a town, street or landmark there.');
      }
      function shortLinkNote() {
        message('That is a shortened Google Maps link, which hides the location. Open it and copy the full address bar instead.');
      }
      function paint() {
        var nodes = list.querySelectorAll('.mmf-sugg__item[role="option"]');
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].classList.toggle('is-active', i === active);
          nodes[i].setAttribute('aria-selected', i === active ? 'true' : 'false');
        }
        if (active >= 0 && nodes[active]) {
          input.setAttribute('aria-activedescendant', nodes[active].id);
          try { nodes[active].scrollIntoView({ block: 'nearest' }); } catch (e) {}
        }
      }
      function row(icon, name, ctx, q) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mmf-sugg__item';
        b.innerHTML = icon + '<span class="mmf-sugg__txt"><span class="mmf-sugg__name"></span><span class="mmf-sugg__ctx"></span></span>';
        if (q) highlight(b.querySelector('.mmf-sugg__name'), name, q);
        else b.querySelector('.mmf-sugg__name').textContent = name;
        b.querySelector('.mmf-sugg__ctx').textContent = ctx || '';
        b.addEventListener('mousedown', function (e) { e.preventDefault(); });
        return b;
      }
      function option(b, o, i) {
        b.id = list.id + '-' + i;
        b.setAttribute('role', 'option');
        b.setAttribute('aria-selected', 'false');
        b.addEventListener('click', function () { choose(o); });
        list.appendChild(b);
      }
      function credit(res) {
        if (!res.length) return;
        var d = document.createElement('div');
        d.className = 'mmf-sugg__credit';
        d.textContent = (mtKey && !res[0].src ? '© MapTiler ' : '') + '© OpenStreetMap contributors';
        list.appendChild(d);
      }
      function show(res, q) {
        list.innerHTML = ''; items = res; active = -1; shownFor = q;
        res.forEach(function (o, i) { option(row(PIN, o.name, o.ctx, o.coords ? '' : q), o, i); });
        credit(res);
        open();
      }
      /* Empty box: "Use my current location", then recent places. */
      function showStart() {
        var rec = recentGet();
        list.innerHTML = ''; items = []; active = -1; shownFor = '';
        if (!canLocate && !rec.length) { hide(); return; }
        if (canLocate) {
          var lo = { locate: true, name: locLabel };
          var b = row(LOC, locLabel, '');
          b.classList.add('mmf-sugg__item--loc');
          items.push(lo); option(b, lo, 0);
        }
        if (rec.length) {
          var h = document.createElement('div');
          h.className = 'mmf-sugg__head';
          h.textContent = 'Recent';
          list.appendChild(h);
          rec.forEach(function (o) { o.recent = true; items.push(o); option(row(CLOCK, o.name, o.ctx), o, items.length - 1); });
        }
        open();
      }
      function locate() {
        seq++;
        busy(true);
        message('Finding your location…');
        navigator.geolocation.getCurrentPosition(function (p) {
          var lat = p.coords.latitude, lon = p.coords.longitude;
          geo.reverse(lat, lon).then(function (name) {
            input.value = name || fmtCoord(lat, lon);
            hide();
            go(lat, lon, name || '');
          });
        }, function (err) {
          busy(false);
          if (err && err.code === 1) {
            canLocate = false;
            try { sessionStorage.setItem('mmf-loc-off', '1'); } catch (eS) {}
          }
          message(err && err.code === 1
            ? 'Location is switched off for this site. Type your address instead.'
            : "We couldn't find your location. Type your address instead.");
        }, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 });
      }
      /* Instant first row while typing: "Search "grafton st"". Enter or a
         tap runs the fast search straight away. */
      function searchRow(q) {
        list.innerHTML = ''; items = []; active = -1; shownFor = '';
        var b = row(LENS, 'Search “' + q + '”', '');
        b.classList.add('mmf-sugg__item--go');
        var k = document.createElement('kbd');
        k.className = 'mmf-sugg__key';
        k.textContent = 'Enter';
        b.appendChild(k);
        b.addEventListener('click', function () { submit(); });
        list.appendChild(b);
        open();
      }
      /* Put an answer on screen if it still fits what is in the box now. */
      function present(res, q) {
        var now = input.value.trim();
        if (now === q) return show(res, q);
        if (norm(now).indexOf(norm(q)) === 0) {
          var f = fits(res, now);
          if (f.length) show(f, now);
        }
      }
      /* v2.0.4: where the page was before the box was tapped (phones). */
      var Y0 = null;
      function settleBack() {
        try {
          if (Y0 === null || !window.matchMedia('(max-width: 749px)').matches) return;
          input.blur();
          window.scrollTo(0, Y0);
        } catch (e) {}
      }
      function go(lat, lon, name) {
        busy(true);
        settleBack();
        window.location.href = link('mmq=' + encodeURIComponent(lat.toFixed(5) + ',' + lon.toFixed(5)) +
          (name ? '&mmn=' + encodeURIComponent(name) : ''));
      }
      function choose(o) {
        if (o.locate) return locate();
        if (o.big) return tooBig(o);
        if (!o.coords) recentAdd(o);
        seq++;
        input.value = o.ctx && !o.coords ? o.name + ', ' + o.ctx : o.name;
        hide();
        go(o.lat, o.lon, o.coords ? '' : o.name);
      }
      function suggest(q) {
        var my = ++seq;
        var pt = parseCoords(q);
        if (pt && pt.shortLink) return shortLinkNote();
        if (pt) return show([{ name: fmtCoord(pt.lat, pt.lon), ctx: 'Coordinates',
                               lat: pt.lat, lon: pt.lon, big: false, coords: true }], q);
        geo.suggest(q, focusPoint()).then(function (res) {
          if (my !== seq) return;
          if (!res) return;                       /* no answer: keep the Search row */
          if (res.length) return present(res, q);
          if (geo.pcKind(q) && input.value.trim() === q) noMatch(q);
        }).catch(function () { /* aborted or failed: keep what is shown */ });
      }
      function refresh() {
        var q = input.value.trim();
        if (timer) { clearTimeout(timer); timer = null; }
        if (q.length < MIN) { seq++; if (!q.length && document.activeElement === input) showStart(); else hide(); return; }
        if (parseCoords(q)) return suggest(q);
        var c = geo.cached(q);
        if (c) { seq++; return show(c, q); }
        var keep = (items.length && shownFor && norm(q).indexOf(norm(shownFor)) === 0) ? fits(items, q) : [];
        if (keep.length) show(keep, q); else searchRow(q);
        timer = setTimeout(function () { timer = null; suggest(q); }, WAIT);
      }
      /* Enter / Build it: the highlighted suggestion, else the first one on
         screen for this exact text, else the fast search's FIRST match -- the
         configurator's Enter rule. A first match that is a whole country is
         refused, never swapped for a later one. */
      function submit() {
        if (timer) { clearTimeout(timer); timer = null; }
        var q = input.value.trim();
        if (q.length < 2) { input.focus(); return; }
        if (active >= 0 && items[active]) return choose(items[active]);
        var pt = parseCoords(q);
        if (pt && pt.shortLink) return shortLinkNote();
        if (pt) { hide(); return go(pt.lat, pt.lon, ''); }
        if (items.length && shownFor === q) return choose(items[0]);
        var my = ++seq;
        busy(true);
        message('Finding “' + q + '”…');
        var limit = new Promise(function (r) { setTimeout(function () { r('timeout'); }, 6000); });
        Promise.race([geo.search(q, focusPoint()), limit]).then(function (res) {
          if (my !== seq) return;
          busy(false);
          if (res === 'timeout') return fallback(q);
          if (!res || !res.length) return noMatch(q);
          choose(res[0]);
        }).catch(function (e) {
          if (my !== seq) return;
          busy(false);
          if (e && e.name === 'AbortError') return hide();
          fallback(q);
        });
      }
      /* Search services unreachable from here: hand the text to the
         configurator, which has its own fallbacks. */
      function fallback(q) {
        busy(true);
        settleBack();
        window.location.href = link('mmq=' + encodeURIComponent(q));
      }

      input.addEventListener('input', refresh);
      input.addEventListener('focus', function () {
        try { Y0 = window.pageYOffset || document.documentElement.scrollTop || 0; } catch (eY) {}
        if (list.hidden && !btn.disabled) refresh();
        /* Phones: lift the box towards the top so the list is not hidden
           behind the keyboard. */
        try {
          if (window.matchMedia('(max-width: 749px)').matches) {
            setTimeout(function () {
              var r = form.getBoundingClientRect();
              if (r.top > window.innerHeight * 0.22) window.scrollBy({ top: r.top - 76, behavior: 'smooth' });
            }, 260);
          }
        } catch (e) {}
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!items.length) return;
          e.preventDefault();
          active = e.key === 'ArrowDown'
            ? (active + 1) % items.length
            : (active <= 0 ? items.length - 1 : active - 1);
          paint();
        } else if (e.key === 'Escape') {
          hide();
        }
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      /* v1.8: a tapped row can be gone by now (a message replaced it), so ask
         where the click happened, not where its target is now. */
      document.addEventListener('click', function (e) {
        var path = e.composedPath ? e.composedPath() : [];
        if (path.indexOf(form) >= 0 || form.contains(e.target)) return;
        hide();
      });
      /* Back button from the configurator restores this page from cache with
         the button still saying it is busy. */
      window.addEventListener('pageshow', function (e) { busy(false); if (e.persisted) { hide(); Y0 = null; } });
    }

    /* ------------------------------------------------------------------
       v2.0 place prompts ("What place to choose?"), moved in from the
       mm-place-prompts section. A tap focuses THIS hero's search box in
       the same tap (so phones open the keyboard), then scrolls it to the
       middle of the screen, swaps its hint text and marks the pill.
       ------------------------------------------------------------------ */
    function wirePrompts(box) {
      if (box.getAttribute('data-mmf-ready')) return;
      box.setAttribute('data-mmf-ready', '1');
      var hero = box.closest('.mmf-hero') || box.parentNode;
      box.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.mmf-prompt') : null;
        if (!b || !box.contains(b)) return;
        var on = box.querySelectorAll('.mmf-prompt[aria-pressed="true"]');
        for (var i = 0; i < on.length; i++) on[i].setAttribute('aria-pressed', 'false');
        b.setAttribute('aria-pressed', 'true');
        var input = hero.querySelector('.mmf-hero__copy form input.mmf-search__input') || hero.querySelector('.mmf-search__input');
        if (!input) {
          var f = hero.querySelector('[data-mmf-search]');
          window.location.href = (f && f.getAttribute('data-cfg')) || '/pages/configurator';
          return;
        }
        var hint = b.getAttribute('data-hint');
        if (hint) input.setAttribute('placeholder', hint);
        var reduce = false;
        try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (eM) {}
        try { input.focus({ preventScroll: true }); } catch (eF) { input.focus(); }
        /* reduced motion: 'instant', because the theme sets scroll-behavior:smooth on html, so 'auto' would still glide */
        try { input.scrollIntoView({ behavior: reduce ? 'instant' : 'smooth', block: 'center' }); }
        catch (eS) { try { input.scrollIntoView({ block: 'center' }); } catch (eS2) { input.scrollIntoView(); } }
      });
    }

    function init(root) {
      paintStrips(root);
      var forms = (root || document).querySelectorAll('[data-mmf-search]');
      for (var i = 0; i < forms.length; i++) wire(forms[i]);
      var boxes = (root || document).querySelectorAll('[data-mmf-prompts]');
      for (var j = 0; j < boxes.length; j++) wirePrompts(boxes[j]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-promise"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['home-promise'] = 'v1.1';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-home-steps"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['home-steps'] = 'v1.1';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-made"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['home-made'] = 'v1.1.1';
  /* Swipe indicator (home layering v1, 25 Oct 2026). Shared by MM real photos and
     MM how it's made; whichever loads first wires every indicator on the page.
     Shows only while its row can actually scroll sideways. Before the first swipe the
     bar plays a hint and the arrow nudges; after it the bar follows the row and the
     arrow fades out. */
  (function () {
    if (window.__mmSwipe) return;
    window.__mmSwipe = true;
    function wire(ind) {
      if (ind.getAttribute('data-mm-swipe-ready')) return;
      var row = ind.parentNode && ind.parentNode.querySelector(ind.getAttribute('data-mm-swipe'));
      var track = ind.querySelector('.mm-swipe__track');
      var thumb = ind.querySelector('.mm-swipe__thumb');
      if (!row || !track || !thumb) return;
      ind.setAttribute('data-mm-swipe-ready', '1');
      var raf = 0;
      function paint() {
        raf = 0;
        var max = row.scrollWidth - row.clientWidth;
        var on = max > 4;
        ind.classList.toggle('is-on', on);
        if (!on) return;
        var tw = track.clientWidth || 80;
        var w = Math.max(16, Math.round(tw * row.clientWidth / row.scrollWidth));
        thumb.style.width = w + 'px';
        ind.style.setProperty('--mm-sw-max', (tw - w) + 'px');
        if (ind.classList.contains('is-swiped')) {
          var p = Math.min(1, Math.max(0, row.scrollLeft / max));
          thumb.style.transform = 'translateX(' + Math.round(p * (tw - w)) + 'px)';
        }
      }
      function later() { if (!raf) raf = requestAnimationFrame(paint); }
      row.addEventListener('scroll', function () {
        if (!ind.classList.contains('is-swiped') && row.scrollLeft > 8) ind.classList.add('is-swiped');
        later();
      }, { passive: true });
      window.addEventListener('resize', later);
      window.addEventListener('load', later);
      paint();
    }
    function init(root) {
      var n = (root || document).querySelectorAll('[data-mm-swipe]');
      for (var i = 0; i < n.length; i++) wire(n[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-press"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['press'] = 'v1.3';

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-real"] && !Shopify.designMode) return;
  try {
    
  (window.MM_BUILDS = window.MM_BUILDS || {})['real-photos'] = 'v1.3.1';
  /* Swipe indicator (home layering v1, 25 Oct 2026). Shared by MM real photos and
     MM how it's made; whichever loads first wires every indicator on the page.
     Shows only while its row can actually scroll sideways. Before the first swipe the
     bar plays a hint and the arrow nudges; after it the bar follows the row and the
     arrow fades out. */
  (function () {
    if (window.__mmSwipe) return;
    window.__mmSwipe = true;
    function wire(ind) {
      if (ind.getAttribute('data-mm-swipe-ready')) return;
      var row = ind.parentNode && ind.parentNode.querySelector(ind.getAttribute('data-mm-swipe'));
      var track = ind.querySelector('.mm-swipe__track');
      var thumb = ind.querySelector('.mm-swipe__thumb');
      if (!row || !track || !thumb) return;
      ind.setAttribute('data-mm-swipe-ready', '1');
      var raf = 0;
      function paint() {
        raf = 0;
        var max = row.scrollWidth - row.clientWidth;
        var on = max > 4;
        ind.classList.toggle('is-on', on);
        if (!on) return;
        var tw = track.clientWidth || 80;
        var w = Math.max(16, Math.round(tw * row.clientWidth / row.scrollWidth));
        thumb.style.width = w + 'px';
        ind.style.setProperty('--mm-sw-max', (tw - w) + 'px');
        if (ind.classList.contains('is-swiped')) {
          var p = Math.min(1, Math.max(0, row.scrollLeft / max));
          thumb.style.transform = 'translateX(' + Math.round(p * (tw - w)) + 'px)';
        }
      }
      function later() { if (!raf) raf = requestAnimationFrame(paint); }
      row.addEventListener('scroll', function () {
        if (!ind.classList.contains('is-swiped') && row.scrollLeft > 8) ind.classList.add('is-swiped');
        later();
      }, { passive: true });
      window.addEventListener('resize', later);
      window.addEventListener('load', later);
      paint();
    }
    function init(root) {
      var n = (root || document).querySelectorAll('[data-mm-swipe]');
      for (var i = 0; i < n.length; i++) wire(n[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
